import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';
import { SurveyAuthService } from '../../../../shared/survey-auth.service';
import { SurveyUser } from '../models/survey-user';

@Injectable()
export class SurveyUserService {
  isLoggedIn = false;

  constructor(private http: HttpClient, private auth: SurveyAuthService) {}

  getUserProfileInfo(): Observable<SurveyUser> {
    const get_url = `${environment.surveyApiHost}/api/v1/user-profile`;
    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .get(get_url, { headers: headers })
      .map(this.processResponse)
      .catch(this.handleError);
  }

  getDmisProfileInfo(): Observable<Object> {
    const get_url = `${environment.surveyApiHost}/api/v1/dmis-profile`;
    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .get(get_url, { headers: headers })
      .map((response: HttpResponse<any>) => {
        return response;
      })
      .catch(this.handleError);
  }

  acceptEmailUploadAgreement(): Observable<Object> {
    const put_url = `${environment.surveyApiHost}/api/v1/dmis-profile`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .put(put_url, { email_upload_agreement: true }, { headers: headers })
      .map((response: HttpResponse<any>) => {
        return response;
      })
      .catch(this.handleError);
  }

  updateUserProfileInfo(user: SurveyUser): Observable<SurveyUser> {
    const put_url = `${environment.surveyApiHost}/api/v1/user-profile`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .put(put_url, user, { headers: headers })
      .map(this.processResponse)
      .catch(this.handleError);
  }

  private processResponse(res: HttpResponse<any>): SurveyUser {
    console.log('processResponse: res: ', res);
    const body = res.body.json();
    console.log('processResponse: body: ', body);
    const user = Object.create(SurveyUser.prototype);
    const obj = Object.assign(user, body, {});
    return obj || {};
  }

  private handleError(error: HttpResponse<any> | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpResponse) {
      const body = error.body.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
